import {Helmet} from 'react-helmet';
import {LANGUAGES, DEFAULT_LANGUAGE, OG_LOCALES, SITE_URL, buildUrl, ogLanguage} from '../services/language';

const OG_IMAGE_WIDTH = 1200;
const OG_IMAGE_HEIGHT = 630;

// Everything search engines and link previews read from <head>.
// path      — page path without the language: '/', '/pt-mobile'
// localized — the page exists in every language (adds hreflang); false for FAQ and policies
// canonical — full URL, overrides the one built from lang + path
const Seo = ({
  lang,
  path = '/',
  localized = true,
  canonical,
  title,
  description,
  image,
  imageAlt,
  noindex = false,
  jsonLd,
}) => {
  const url = canonical || (localized ? buildUrl(lang, path) : `${SITE_URL}${path}`);
  // Link preview image: one per page and language, 1200×630 (public/og)
  const imageUrl = `${SITE_URL}${image || `/og/home-${ogLanguage(lang)}.png`}`;

  return (
    <Helmet>
      <html lang={lang}/>
      {title ? <title>{title}</title> : null}
      {description ? <meta name="description" content={description}/> : null}
      {noindex ? <meta name="robots" content="noindex"/> : null}

      <link rel="canonical" href={url}/>
      {localized ? LANGUAGES.map((code) => (
        <link key={code} rel="alternate" hrefLang={code} href={buildUrl(code, path)}/>
      )) : null}
      {localized ? <link rel="alternate" hrefLang="x-default" href={buildUrl(DEFAULT_LANGUAGE, path)}/> : null}

      <meta property="og:type" content="website"/>
      <meta property="og:site_name" content="chernykh.tech"/>
      <meta property="og:url" content={url}/>
      <meta property="og:locale" content={OG_LOCALES[lang] || OG_LOCALES[DEFAULT_LANGUAGE]}/>
      {localized ? LANGUAGES.filter((code) => code !== lang).map((code) => (
        <meta key={code} property="og:locale:alternate" content={OG_LOCALES[code]}/>
      )) : null}
      {title ? <meta property="og:title" content={title}/> : null}
      {description ? <meta property="og:description" content={description}/> : null}
      <meta property="og:image" content={imageUrl}/>
      <meta property="og:image:width" content={String(OG_IMAGE_WIDTH)}/>
      <meta property="og:image:height" content={String(OG_IMAGE_HEIGHT)}/>
      {imageAlt ? <meta property="og:image:alt" content={imageAlt}/> : null}

      <meta name="twitter:card" content="summary_large_image"/>
      {title ? <meta name="twitter:title" content={title}/> : null}
      {description ? <meta name="twitter:description" content={description}/> : null}
      <meta name="twitter:image" content={imageUrl}/>

      {jsonLd ? <script type="application/ld+json">{JSON.stringify(jsonLd)}</script> : null}
    </Helmet>
  );
};

export default Seo;
